<section class="after-login">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="title-strip my-5">
                    <h2 class="text-primary">My Pets</h2>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="default-box p-4 rounded-4">
                    <div class="inner-box shadow-sm bg-white rounded-4 p-4">
                        <div class="row">
                            <div class="col-lg-3 col-xl-5">
                                <div class="img-box overflow-hidden rounded-4">
                                    @if (petInformation?.avatar) {
                                    @if (isPetAvailable) {
                                    <img [src]="petInformation?.avatar ? filePathPet +  petInformation?.id + '/' +  petInformation?.avatar : 'default.png'"
                                        alt="{{ petInformation?.name }}" class="h-100 w-100" />
                                    }
                                    }@else {
                                    <ngx-avatars class="pet-detail-profile-icon" bgColor="{{ avatar_bg_color }}"
                                        fgColor="{{ avatar_fg_color }}" [round]="false" [cornerRadius]="10"
                                        name="{{ petInformation?.name }}">
                                    </ngx-avatars>
                                    }
                                </div>
                            </div>
                            <div class="col-lg-9 col-xl-7">
                                <div class="d-flex flex-column h-100">
                                    <div class="row">
                                        <div class="col-12">
                                            <h4 class="mb-4">
                                                <span class="text-primary">
                                                    {{ petInformation?.name | titlecase }}
                                                </span>
                                                ({{ petInformation?.pet_type_title }})

                                                @if(petInformation && petInformation?.is_active){
                                                <span class="text-info">(Active)</span>
                                                }@else if(petInformation && !petInformation?.is_active){
                                                <span class="text-danger"> (In Active)</span>
                                                }
                                            </h4>
                                        </div>
                                        <div class="col-6 mb-4">
                                            <div class="text-uppercase">Breed</div>
                                            <div class="h6 text-info m-0">
                                                {{ petInformation?.breed ? petInformation?.breed : "N/A"}}
                                            </div>
                                        </div>
                                        <div class="col-6 mb-4">
                                            <div class="text-uppercase">Age</div>
                                            <div class="h6 text-info m-0">
                                                {{petInformation?.age ? petInformation?.age + " year" : "N/A"}}
                                            </div>
                                        </div>
                                        <div class="col-6 mb-4">
                                            <div class="text-uppercase">Sex</div>
                                            <div class="h6 text-info m-0">
                                                {{ petInformation?.sex ? petInformation?.sex : "N/A"}}
                                            </div>
                                        </div>
                                        <div class="col-6 mb-4">
                                            <div class="text-uppercase">Colour</div>
                                            <div class="h6 text-info m-0">
                                                {{petInformation?.color ? petInformation?.color : "N/A"}}
                                            </div>
                                        </div>
                                        <div class="col-6 mb-4">
                                            <div class="text-uppercase">Weight</div>
                                            <div class="h6 text-info m-0">
                                                {{ petInformation?.weight ? petInformation?.weight + " lb" : "N/A"}}
                                            </div>
                                        </div>
                                        <div class="col-6 mb-4">
                                            <div class="text-uppercase">Microchip</div>
                                            <div class="h6 text-info m-0">
                                                {{ petInformation?.microchip ? petInformation?.microchip : "N/A"}}
                                            </div>
                                        </div>
                                        <div class="col-6 mb-4">
                                            <div class="text-uppercase">Identification Mark</div>
                                            <div class="h6 text-info m-0">
                                                {{ petInformation?.description ? petInformation?.description : "N/A"}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-auto">
                                        <div
                                            class="d-flex justify-content-between align-items-center flex-column flex-md-row gap-3 gap-md-0">
                                            @if(petInformation?.is_active){
                                            <a (click)="openPetEditModal()" class="btn btn-success cursor-pointer">Edit
                                                {{ petInformation?.name }}’s
                                                Details</a>
                                            }
                                            @if (petInformation?.has_active_health_map != undefined) {
                                            @if (petInformation?.has_active_health_map != 'N/A') {
                                            @if (petInformation?.has_active_health_map) {
                                            <a [routerLink]="[ '/health_map_report/', petInformation?.pet_identity,'healthMap']"
                                                class="text-secondary link cursor-pointer">View Health Map</a>
                                            }@else {
                                            @if(petInformation?.is_active){
                                            <a class="text-danger link cursor-pointer"
                                                [routerLink]="['/health-map/', petInformation?.pet_identity]">
                                                Generate Health Map
                                            </a>
                                            }
                                            }
                                            }
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="inner-box shadow-sm bg-white rounded-4 p-3 p-sm-5 mt-5 boarding-exp-sec">
                        <div class="row outer-box">
                            <div class="col-lg-6">
                                <div class="pe-5">
                                    <h3 class="text-primary">Give Your Pet The Best Boarding Experience <span
                                            class="text-secondary">Book Now!!</span></h3>
                                    <p>Please select your check-in and Check-out Dates and the number of pets you would
                                        like
                                        to board, when you click check availability you will be able to select the
                                        kennel
                                        type for your booking.</p>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-box inner-box shadow-sm bg-white rounded-4 p-4">
                                    <form action="" class="d-flex flex-column align-items-center h-100">
                                        <p-calendar [appendTo]="'body'"
                                            class="orm-input form-input-with-box iconic-feild order-date-picker w-100 mb-3"
                                            placeholder="Select check-in date" [(ngModel)]="inwardDate"
                                            [minDate]="minInWardDate" [maxDate]="maxDate"
                                            [dateFormat]="pCalendarDateFormat" (onSelect)="selectInwardDate()"
                                            [ngModelOptions]="{ standalone: true }" [readonlyInput]="true"
                                            hideOnDateTimeSelect="true" [showIcon]="true" styleClass="p-calendar">
                                            <ng-template pTemplate="date" let-date>
                                                <span [ngStyle]="{
                                              backgroundColor: getSelectedDays(date)
                                                ? '#005b9f'
                                                : 'inherit',
                                              color: getSelectedDays(date) ? 'white' : 'inherit'
                                            }" class="selected-inward">{{ date.day }}</span>
                                            </ng-template>
                                        </p-calendar>

                                        <p-calendar [appendTo]="'body'"
                                            class="form-input form-input-with-box iconic-feild order-date-picker w-100 mb-3"
                                            placeholder="Select check-out date" #checkout [disabled]="!inwardDate"
                                            [(ngModel)]="outwardDate" [minDate]="inwardDate"
                                            [dateFormat]="pCalendarDateFormat" (onSelect)="selectOutwardDate()"
                                            [readonlyInput]="true" [ngModelOptions]="{ standalone: true }"
                                            [showIcon]="true" styleClass="p-calendar">
                                            <ng-template pTemplate="date" let-date>
                                                <span
                                                    [ngStyle]="{backgroundColor: getSelectedDays(date)? '#005b9f' : 'inherit',color: getSelectedDays(date) ? 'white' : 'inherit'}"
                                                    class="selected-outward">{{ date.day }}</span>
                                            </ng-template>
                                        </p-calendar>
                                        <a (click)="!petInformation?.is_active
                                        ? $event.preventDefault()
                                        : checkCageAvailability()"
                                            [ngbTooltip]="!petInformation?.is_active?'This pet is In active':''"
                                            [ngClass]="{ disabled: !petInformation?.is_active }"
                                            class="btn btn-success w-100 cursor-pointer">Check
                                            Availability</a>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-box overflow-hidden my-5 mb-0">
                        <div class="title">{{ petInformation?.name }}'s Boarding</div>
                        <div class="table-responsive">
                            <table class="table mb-0">
                                <thead>
                                    <tr>
                                        <th>Check in date</th>
                                        <th>Check Out date</th>
                                        <th>Booking Days</th>
                                        <th>Cage No</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (boarding of boardingList; track $index) {
                                    <tr>
                                        <td>{{ boarding?.inward_time | date : format }}</td>
                                        <td>{{ boarding?.outward_time | date : format }}</td>
                                        <td>{{ boarding?.book_days }}</td>
                                        <td>{{ boarding?.cage_no }}</td>
                                        <td>{{ boarding?.show_booking_status }}</td>
                                        <td>
                                            @if(petInformation?.is_active){
                                            <a class="cursor-pointer" [routerLink]="[
                                                '/booking/detail',
                                                boarding.booking_id ? boarding.booking_id : boarding.id
                                              ]">
                                                <i class="fa-regular fa-eye fs-6"></i>
                                            </a>
                                            }@else {
                                            N/A
                                            }
                                        </td>
                                    </tr>
                                    }
                                    @empty {
                                    <tr>
                                        <td colspan="7" class="text-center">No Records to Show!</td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    @if (boardingList?.length) {
                    <div class="custom-pagination">
                        <!-- pagination dynamic code put here -->
                        <p-paginator #paginat [rows]="paginateForBoarding.per_page"
                            [totalRecords]="paginateForBoarding.total"
                            (onPageChange)="paginateApply($event,'boarding')">
                        </p-paginator>
                    </div>
                    }
                    <div class="row my-5">
                        <div [ngClass]="{'col-12': activeSubscription,'col-lg-6 ':!activeSubscription}">
                            <div class="inner-box shadow-sm bg-white rounded-4 p-4">
                                <div class="row">
                                    <div class="col-12">
                                        <h6 class="text-primary"> {{ petInformation?.name }}'s Current Wellness Plan
                                        </h6>
                                        <p>Wellness plan information for our future medical records.</p>
                                    </div>
                                    <div class="col-12">
                                        <hr>
                                    </div>
                                    <div class="col-12">
                                        <div class="row">
                                            @if (activeSubscription) {
                                            <div class="col-lg-5 align-self-center">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <h6 class="text-info">{{ activeSubscription?.plan_level?.title
                                                            }}</h6>
                                                        <div>
                                                            {{
                                                            activeSubscription?.plan_level?.plan?.name
                                                            ? "(" + activeSubscription?.plan_level?.plan?.name + ")"
                                                            : ""
                                                            }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            }
                                            <div
                                                [ngClass]="{'col-lg-7 mt-3 mt-lg-0': activeSubscription,'col-12':!activeSubscription}">
                                                <div class="row">

                                                    <div class="col-6 mb-3">
                                                        <div class="text-uppercase">Subscription Period</div>
                                                        <div class="h6 text-info m-0">
                                                            {{
                                                            activeSubscription?.plan_level?.months
                                                            ? activeSubscription?.plan_level?.months + " Months"
                                                            : "N/A"
                                                            }}
                                                        </div>
                                                    </div>
                                                    <div class="col-6 mb-3">
                                                        <div class="text-uppercase">Price</div>
                                                        <div class="h6 text-info m-0">
                                                            {{
                                                            activeSubscription?.plan_level?.price
                                                            ? (activeSubscription?.plan_level?.price | currency)
                                                            : "N/A"
                                                            }}
                                                        </div>
                                                    </div>
                                                    <div class="col-6">
                                                        <div class="text-uppercase">Minimum Period</div>
                                                        <div class="h6 text-info m-0">
                                                            {{
                                                            activeSubscription?.plan_level?.minimum_months
                                                            ? activeSubscription?.plan_level?.minimum_months +
                                                            " Months"
                                                            : "N/A"
                                                            }}
                                                        </div>
                                                    </div>
                                                    <div class="col-6">
                                                        <div class="text-uppercase">Start Date</div>
                                                        <div class="h6 text-info m-0">{{
                                                            activeSubscription?.created_at
                                                            ? (activeSubscription?.created_at | date : format)
                                                            : "N/A"}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-box overflow-hidden my-5">
                        <div class="table-responsive">
                            <table class="table mb-0">
                                <thead>
                                    <tr>
                                        @if (!activeSubscription?.is_new_subscription) {
                                        <th>
                                            Features Name
                                        </th>
                                        }
                                        @if (activeSubscription?.is_new_subscription) {
                                        <th>
                                            Services Name
                                        </th>
                                        }
                                        <th>Total</th>
                                        <th>Used</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (feature of activeSubscription?.services; track $index) {
                                    <tr>
                                        <td>{{ feature?.title }}</td>
                                        <td>{{ feature?.subscribed_value }} times</td>
                                        <td>
                                            {{ feature?.used_value ? feature?.used_value : "0" }} times
                                        </td>
                                    </tr>

                                    }
                                    @if (!activeSubscription || activeSubscription == null) {
                                    <tr>
                                        <td colspan="3" class="text-center">No Records to Show!</td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="table-box overflow-hidden my-5">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="title">
                                Opted
                                {{
                                activeSubscription?.is_new_subscription
                                ? "Extra Services"
                                : "
                                Add-ons"
                                }}
                            </div>
                            <div class="px-3">
                                List of
                                {{
                                activeSubscription?.is_new_subscription
                                ? "Extra Services"
                                : " Add-on"
                                }}
                                that {{ petInformation?.name }} is having in it's plan.
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table mb-0">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Price</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (addonDetails of activeSubscription?.extra_services; track addonDetails; let i
                                    = $index) {
                                    <tr>
                                        @if (!activeSubscription?.is_new_subscription) {
                                        <td>
                                            {{ addonDetails?.addon?.title }}
                                        </td>
                                        }
                                        @if (activeSubscription?.is_new_subscription) {
                                        <td>
                                            {{ addonDetails?.title }}
                                        </td>
                                        }
                                        @if (!activeSubscription?.is_new_subscription) {
                                        <td>
                                            {{ addonDetails?.price | currency }}
                                        </td>
                                        }
                                        @if (activeSubscription?.is_new_subscription) {
                                        <td>
                                            {{ addonDetails?.monthly_amount | currency }}
                                        </td>
                                        }
                                        <td>{{ addonDetails?.status | titlecase }}</td>
                                        <td>
                                            @if (
                                            addonDetails?.is_used != '1' &&
                                            addonDetails.status == 'active' ||petInformation?.is_active
                                            ) {
                                            <a href="javascript:void(0)" class="text-info link"
                                                (click)="unsubscribe(addonDetails)">Unsubscribe</a>
                                            }@else {
                                            <span>N/A</span>
                                            }
                                        </td>
                                    </tr>
                                    }
                                    @if (!activeSubscription || activeSubscription == null) {
                                    <tr>
                                        <td colspan="4" class="text-center">No Records to Show!</td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="table-box overflow-hidden">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="title"> {{ petInformation?.name }}'s Previous Wellness Plan</div>
                        </div>
                        <div class="table-responsive">
                            <table class="table mb-0">
                                <thead>
                                    <tr>
                                        <th>Plan Name</th>
                                        <th>Subscription Name</th>
                                        <th>{{ title }}</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    @for (subscription of subscriptionList; track $index) {
                                    <tr>
                                        <td>
                                            <a href="javascript:void(0)"
                                                [routerLink]="['/subscription/detail', subscription.id]">{{
                                                subscription?.plan_name }}</a>
                                        </td>
                                        <td>{{ subscription?.plan_level_title }}</td>
                                        @if (!subscription?.is_new_subscription) {
                                        <td>
                                            {{ subscription?.number_of_addons }}
                                        </td>
                                        }
                                        @if (subscription?.is_new_subscription) {
                                        <td>
                                            {{ subscription?.number_of_extra_services }}
                                        </td>
                                        }
                                        <td>{{ subscription?.created_at | date : format }}</td>
                                        <td>{{ subscription?.end_on | date : format }}</td>
                                        <td>{{ subscription?.status | titlecase }}</td>
                                        <td>
                                            @if(petInformation?.is_active){
                                            <a href="javascript:void(0)" (click)="goToSubscriptindetail(subscription)">
                                                <i class="icon-eye"></i></a>
                                            }@else{
                                            N/A
                                            }
                                        </td>
                                    </tr>
                                    }

                                    @empty {
                                    <tr>
                                        <td colspan="7" class="text-center">No Records found</td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    @if (subscriptionList?.length) {
                    <div class="custom-pagination">
                        <!-- pagination dynamic code put here -->
                        <p-paginator #paginat [rows]="paginateForPan.per_page" [totalRecords]="paginateForPan.total"
                            (onPageChange)="paginateApply($event,'plan')">
                        </p-paginator>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</section>

<section class="client-say">
    <div class="container position-relative">
        <app-testimonials></app-testimonials>
    </div>
</section>
<section class="contact-form">
    <img [src]="'assets/images/home/form-bg-dog.png'" alt=""
        class="position-absolute start-0 end-0 mx-auto bg-dog mt-5">
    <div class="container">
        <app-contact-us></app-contact-us>
    </div>
</section>

<!-- Edit Pet Detail Start -->
<div class="modal edit-pet-modal custom-modal" id="exampleModalCenter" tabindex="-1" role="dialog"
    aria-labelledby="myExtraLargeModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg zoomIn animated modal-bg-blue"
        role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="text-info" id="exampleModalLongTitle">
                    Edit {{ petInformation?.name }}'s Details
                </h5>
                <button type="button" class="close btn-close" data-dismiss="modal" aria-label="Close"
                    (click)="closeModal()"></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="petDetails">
                    <div class="row mb-4">
                        <div class="form-feild form-feild-full">
                            <div class="upload-block">
                                <div class="custom-btn-update mx-auto mx-lg-0">
                                    <!-- <span class="title-label">Choose Your Pet Image</span> -->
                                    <div
                                        class="pet-img-box rounded-circle justify-content-center d-flex align-items-center mx-auto mb-3 position-relative border border-2">
                                        <app-block-spinner [name]="'pet_detail'"
                                            [isSpinnerShow]="spinnerVariable"></app-block-spinner>

                                        @if (coverImage?.length) {
                                        @for (cimage of coverImage; track $index) {
                                        <img [src]="cimage.path + '/' + cimage.file"
                                            [alt]="cimage.path + '/' + cimage.file"
                                            class="h-100 w-100 rounded-circle" />
                                        <div
                                            class="cursor-pointer position-absolute remove-btn bg-white rounded-circle p-1 border shadow-lg d-flex justify-content-center align-items-center top-0 end-0">
                                            <i class="fa fa-trash error text-danger"
                                                (click)="removeCover(coverImage, cimage.file)"></i>
                                        </div>
                                        }
                                        }@else{
                                        <img [src]="'assets/images/default-img.png'"
                                            class="h-100 w-100 rounded-circle" />
                                        }
                                    </div>
                                    <p-fileUpload #fubauto chooseLabel="Upload Pet Image" mode="basic" name="images[]"
                                        url="{{ upload_pet_image }}" accept="image/*" maxFileSize="{{ maxFileSize }}"
                                        auto="true" (onUpload)="onCoverUploadAuto($event)"
                                        (onSelect)="validateImageFile($event, fubauto)"
                                        (onProgress)="fileUploadProgress()" (onError)="fileUploadError()"
                                        styleClass="text-secondary fw-bold bg-transparent border-0 p-0"
                                        [headers]="tokenHeader">
                                    </p-fileUpload>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 mb-4">
                            <input type="text" trim="blur" id="name" name="name" [formControl]="name"
                                placeholder="Your Pet’s Name" class="form-control" autocomplete="off" />
                            @if ((name?.touched || name?.dirty || submitted) &&!name?.valid &&!name?.pending) {
                            @if (name?.errors.required) {
                            <span class="text-danger error">
                                Pet's name is required
                            </span>
                            }
                            }
                        </div>
                        <div class="col-md-6 mb-4">
                            <select class="form-select form-control" id="sex" name="sex" [formControl]="sex">
                                <option value="">Select Sex</option>
                                @for (sex_type of select_sex; track $index) {
                                <option value="{{ sex_type }}">
                                    {{ sex_type | titlecase }}
                                </option>
                                }
                            </select>
                            @if ((sex?.touched || sex?.dirty || submitted) &&!sex?.valid && !sex?.pending) {
                            @if (sex?.errors.required) {
                            <span class="text-danger error">Sex is required</span>
                            }
                            }
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3 mb-4">
                            <input type="text" trim="blur" id="age" name="age" [formControl]="age"
                                placeholder="Age (in years)" class="form-control" />
                            @if ( (age?.touched || age?.dirty || submitted) && !age?.valid && !age?.pending ) {
                            <span class="text-danger error">
                                @if (age?.errors.required) {Age is required}
                                @if (age?.errors.pattern) {Age Should be valid numeric value}
                            </span>
                            }
                        </div>
                        <div class="col-md-3 mb-4">
                            <input type="text" trim="blur" id="weight" name="weight" [formControl]="weight"
                                placeholder="Weight (in lbs)" class="form-control" />
                            @if ((weight?.touched || weight?.dirty || submitted) && !weight?.valid && !weight?.pending)
                            {
                            <span class="text-danger error">
                                @if (weight?.errors.required) {Weight is required}
                                @if (weight?.errors.pattern) {Weight Should be valid numeric value}
                            </span>
                            }
                        </div>
                        <div class="col-md-3 mb-4">
                            <input type="text" trim="blur" id="breed" name="breed" [formControl]="breed"
                                placeholder="Breed" class="form-control" />
                            @if ( (breed?.touched || breed?.dirty || submitted) && !breed?.valid && !breed?.pending) {
                            @if (breed?.errors.required) {
                            <span class="text-danger error">
                                Breed is required
                            </span>
                            }
                            }
                        </div>
                        <div class="col-md-3 mb-4">
                            <input type="text" trim="blur" id="color" name="color" [formControl]="color"
                                placeholder="Color" class="form-control" />
                            @if ((color?.touched || color?.dirty || submitted) && !color?.valid && !color?.pending) {
                            @if (color?.errors.required) {
                            <span class="text-danger error">
                                Color is required
                            </span>
                            }
                            }
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 mb-4">
                            <input type="text" trim="blur" id="microchip" name="microchip" [formControl]="microchip"
                                placeholder="Microchip" class="form-control" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <textarea id="description" class="form-control" name="description"
                                placeholder="Dentification Mark" [formControl]="description" rows="3">
                                </textarea>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" (click)="savePetDetails()" class="btn btn-success">
                    Save
                </button>
            </div>
        </div>
    </div>
</div>

<!-- End -->

<!-- Check Availability popup section (with plugin) -->
<div class="modal bd-example-modal-xl custom-modal" id="cageSelectionModal" tabindex="-1" role="dialog"
    aria-labelledby="myExtraLargeModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered  modal-xl zoomIn animated modal-bg-blue"
        role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="text-info" id="exampleModalLongTitle">
                    Select Cage for {{ petInformation?.name | titlecase }}
                </h5>
                <button type="button" class="close btn-close" data-dismiss="modal" aria-label="Close"
                    (click)="closeModal()"></button>

            </div>
            <div class="modal-body">
                <div class="card-list card-list-sm">
                    @if (cageList && cageList.length) {
                    <div class="row cage-listing">
                        @for (cage of cageList; track $index) {
                        <div class="col-xl-4 col-md-6 col-12 mb-4">
                            <div class="cage-box d-flex flex-column">
                                <div>
                                    <figure class="card-figure">
                                        <img class="rounded-3 img-fluid"
                                            [src]="filePathCage + cage.id + '/cover_image/' + cage.default_cover_image"
                                            alt="" />
                                    </figure>
                                </div>

                                @if (!cage?.is_available_for_outpost) {
                                <div class="bottom-link">
                                    <a href="javascript:void(0)" (click)="onSelect(cage, 'other_cage')"><u
                                            class="fw-bold">Click Here</u></a>
                                    and change Center to continue with this Cage.
                                </div>
                                }

                                <h6 class="card-title mb-3">
                                    {{ cage?.title }}
                                </h6>
                                <div class="card-price">
                                    <span class="text-info h6"> {{ cage?.amount | currency }} </span>/day
                                </div>

                                <div class="mt-auto">
                                    <hr />
                                    <div
                                        class="d-flex justify-content-between align-items-center flex-column flex-lg-row">
                                        <div class="size-area mb-3 mb-lg-0">
                                            Size: {{ cage?.width }} x {{ cage?.height }} x
                                            {{ cage?.length }} {{ cage?.unit }}
                                        </div>
                                        <div class="card-btn">
                                            <button class="btn btn-success cursor-pointer"
                                                [ngClass]="{disabled: !cage?.is_available_for_outpost}"
                                                (click)="bookCage(cage)">
                                                <span>Select</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                    }

                    @if (!cageList?.length) {
                    <div class=" col-md-12">
                        <div class="text-center">
                            <p>Oops, seems all cages are booked.</p>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>